<button mat-icon-button (click)="openMap()" tabindex="-1">
  <span class="material-symbols-outlined"> map </span>
</button>
